import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { progressService } from '@/services/progress';
import { useRoute } from 'vue-router';

export function useProgressLevelList() {
    const route = useRoute();
    const crudAction = useCrudActions();

    const progressId = route.params.progressId;

    const { list, total, fetchList } = useBaseListView({
        request: progressService.level.list,
        paramsBuilder: () => ({ progressId })
    });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: progressService.level.remove,
            onSuccess: () => fetchList()
        })
    };

    return { progressId, list, total, fetchList, actions };
}
